import { LTFormControl, LTSelect } from "@lambdatestincprivate/lt-components";
import { Spinner } from "@primer/react";
import React, { useEffect } from "react";

interface ISlackChannelList {
  slackOptions:
    | {
        ok: boolean;
        channels: any[];
        default_channel?: {
          name: string;
          id: string;
        };
      }
    | undefined;
  handleSlackChannelSelect: (values: {
    channel_id: string;
    channel_name: string;
  }) => void;
  selectedSlackChannel:
    | {
        channel_id: string;
        channel_name: string;
      }
    | undefined;
}
const SlackChannelList: React.FC<ISlackChannelList> = ({
  slackOptions,
  handleSlackChannelSelect,
  selectedSlackChannel,
}) => {
  useEffect(() => {
    if (slackOptions?.default_channel) {
      handleSlackChannelSelect({
        channel_id: slackOptions.default_channel.id,
        channel_name: slackOptions.default_channel.name,
      });
    }
    // else if (slackOptions?.channels) {
    //   handleSlackChannelSelect({
    //     channel_id: slackOptions.channels[0].id,
    //     channel_name: slackOptions.channels[0].name,
    //   });
    // }
  }, [slackOptions]);

  return (
    <LTFormControl
      label="Select Default Slack Channel*"
      labelStyle={{
        fontSize: 12,
      }}
      formStyles={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "16px",
      }}
    >
      {slackOptions ? (
        <LTSelect
          options={
            slackOptions?.channels
              ? slackOptions.channels.map((val) => {
                  return {
                    value: val.id, //channel_id
                    name: val.name, //channel_name
                  };
                })
              : []
          }
          defaultSelections={
            selectedSlackChannel
              ? [
                  {
                    value: selectedSlackChannel.channel_id,
                    name: selectedSlackChannel.channel_name,
                  },
                ]
              : [null]
          }
          onChange={(values: any) => {
            handleSlackChannelSelect({
              channel_id: values[0].value, //values.value,
              channel_name: values[0].name, //values.name,
            });
            console.log("channel changed in pipeline", values);
          }}
          withSearch={true}
          customButtonText={
            selectedSlackChannel?.channel_name || "Select channel"
          }
          buttonStyle={{
            width: "196px",
            maxWidth: "196px",
            backgroundColor: "#ffffff",
            '[data-component="buttonContent"]': {
              justifyContent: "start",
              maxWidth: "196px",
              overflow: "Hidden",
              position: "relative",
              display: "inline-block",
              textDecoration: "none",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              textAlign: "left",
            },
          }}
          leadingText=""
        />
      ) : (
        <Spinner size="medium" />
      )}
    </LTFormControl>
  );
};

export default SlackChannelList;
